<template>
  <div>
    <nav class="sidebar">
      <header
        class="logo"
        style="text-align:left;font-size:22px;margin:15px 10px;"
      >
        <a title="Back" @click="$router.go(-1)"
          ><span class="text-warning"
            ><span
              class="glyphicon glyphicon-chevron-left"
              style="top:-1px;"
            ></span>
            Preview</span
          ></a
        >
      </header>

      <p></p>
      <h5 class="navTitle" v-if="$route.params.type === 'spelling'">Spelling Issues</h5>
      <h5 class="navTitle" v-if="$route.params.type === 'link'">Locate Link</h5>
      <ul class="sidebarLabels" v-if="iframeLoaded">
          <div variant="secondary" v-if="$route.params.type === 'link'">
            {{$route.query.focus}}
            <p></p>
            <b-button            variant="outline-dark"
                                 size="sm" @click="highlightLink($route.query.focus)">Show</b-button>

          </div>

          <div variant="secondary" class="card text-dark" style="margin: 5px;" v-for="spellingError in spellingErrors">
            <div class="card-header">
              <div>{{spellingError.word}}
                <b-button
                        @click="approveWord(spellingError)"
                        pill
                        style="float:right"
                        variant="outline-dark"
                        size="sm"
                ><i class="fa fa-thumbs-up"></i
                ></b-button>
              </div>
            </div>
            <div class="card-body"><p class="card-text">
            Suggestion: {{ spellingError.suggestion }}
            </p>


          <div v-if="spellingError.marks.visible.elements.length">
            <small
              >{{ spellingError.marks.visible.elements.length }} occurrence on
              page</small
            >
            <div v-if="spellingError.marks.visible.elements.length > 1">

            <b-button
              pill
              variant="outline-dark"
              size="sm"
              @click="highlightSpelling(spellingError, 'visible', -1)"
              >Prev</b-button
            >
            &nbsp;
            <b-button
              pill
              variant="outline-dark"
              size="sm"
              @click="highlightSpelling(spellingError, 'visible', 1)"
              >Next</b-button
            >
            </div>
            <div v-else>
              <b-button
                      pill
                      variant="outline-dark"
                      size="sm"
                      @click="highlightSpelling(spellingError, 'visible', -1)"
              >Show</b-button
              >
            </div>

          </div>
          <div v-if="spellingError.marks.invisible.elements.length">
            <small>
              {{ spellingError.marks.invisible.elements.length }} invisible
              occurrences</small
            ><br />
            <div v-if="spellingError.marks.invisible.elements.length > 1">

            <b-button
              pill
              variant="outline-dark"
              size="sm"
              @click="highlightSpelling(spellingError, 'invisible', -1)"
              >Prev</b-button
            >
            &nbsp;
            <b-button
              pill
              variant="outline-dark"
              size="sm"
              @click="highlightSpelling(spellingError, 'invisible', 1)"
              >Next</b-button
            >
            </div>
            <div v-else>
              <b-button
                      pill
                      variant="outline-dark"
                      size="sm"
                      @click="highlightSpelling(spellingError, 'invisible', -1)"
              >Show</b-button
              >
            </div>
          </div>
            </div>
          </div>


      </ul>
    </nav>
    <div class="wrap-wide">
      <div class="" style="height:100%">
        <input
          type="text"
          style="width:98%;border-radius:15px;border:0px solid gray;padding:6px;margin:6px"
          disabled
          :value="$route.query.page"
        />
        <a :href="$route.query.page" target="_blank" title="External Link"><i class="fa fa-external-link"></i></a>
        <div
          v-if="!iframeLoaded"
          style="position:absolute;z-index:99;background-color: rgba(237,235,235,0.82);width:100%;height:100%"
        >
          <div
            style="  display: flex;  justify-content: center;  align-items: center; height:100% "
          >
            <div>
              <b-spinner
                style="width: 3rem; height: 3rem;"
                label="Large Spinner"
              ></b-spinner>
            </div>
          </div>
        </div>
        <iframe
          @load="iframeload"
          id="iframe"
          class="iframe"
          frameborder="0"
          sandbox="allow-same-origin allow-scripts"
          style="width:100%"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import Widget from "@/components/Widget/Widget";
import axios from "axios";
import gql from "graphql-tag";

const MARK_OPTIONS_ACCURACY = {
  value: "exactly",
  limiters: [
    "!",
    "@",
    "#",
    "&",
    "*",
    "(",
    ")",
    "-",
    "–",
    "—",
    "+",
    "=",
    "[",
    "]",
    "{",
    "}",
    "|",
    ":",
    ";",
    "'",
    '"',
    "‘",
    "’",
    "“",
    "”",
    ",",
    ".",
    "<",
    ">",
    "/",
    "?"
  ]
};

export default {
  name: "Tables",
  components: { Widget },
  data() {
    return {
      page: {},
      toastOptions: {
        theme: "dark",
        position: "bottomLeft"
      },
      spellingErrors: [],
      selected: null,
      showIndex: -1,
      visible: 0,
      invisible: 0,
      iframeLoaded: false
    };
  },
  apollo: {
    $subscribe: {
      spelling: {
        query() {
          return gql`subscription {
                websites_crawledpage(where:{id: {_eq: ${this.page.id}}}){
                  websites_spellingerror_pages{
                    websites_spellingerror{
                      active
                      word
                      suggestion
                    }
                  }
                }
            }`;
        },
        skip() {
          return !(this.page.id && this.$route.params.type === 'spelling');
        },
        result(data) {
          this.spellingErrors = [];
          for (let errors of data.data.websites_crawledpage[0]
            .websites_spellingerror_pages) {
            if (!errors.websites_spellingerror.active){
              continue;
            }
            this.spellingErrors.push({
              marks: {
                visible: {
                  index: -1,
                  elements: []
                },
                invisible: {
                  index: -1,
                  elements: []
                },
                meta: []
              },
              word: errors.websites_spellingerror.word,
              suggestion: errors.websites_spellingerror.suggestion
            });
          }
        }
      }
    }
  },
  methods: {
    markAll() {
      if (!this.iframeLoaded) {
        return;
      }
      let f = document.getElementById("iframe");
      let m = new f.contentWindow.Mark("body");
      m.unmark({});
      for (let spellingError of this.spellingErrors) {
        this.mark(spellingError);
      }
    },
    approveWord(spellingError) {
      axios
        .put(
          `websites/${this.$route.query.site}/dictionary/${spellingError.word}`
        )
        .then(
          response => {
            this.$toast.show(
              "added to the dictionary",
              spellingError.word,
              this.toastOptions
            );
            return true;
          },
          error => {
            this.$toast.show(error.response.data.message, 'Unauthorized', this.toastOptions);
            return false;
          }
        );
      spellingError.pending = true;
    },
    mark(spellingError) {
      let f = document.getElementById("iframe");
      let m = new f.contentWindow.Mark("body");

      m.mark(spellingError.word, {
        element: "span",
        className: `mark-spelling-errors mark-spelling-errors-w-${
          spellingError.word
        }`,
        separateWordSearch: false,
        accuracy: MARK_OPTIONS_ACCURACY
      });

      let marked_specific = f.contentWindow.document.getElementsByClassName(
        `mark-spelling-errors-w-${spellingError.word}`
      );

      for (let element of marked_specific) {
        if (f.contentWindow.elIsVisible(element)) {
          spellingError.marks.visible.elements.push(element);
        } else {
          spellingError.marks.invisible.elements.push(element);
        }
      }
    },
    getNormalizedUrl(url){
      let a = document.createElement('a');
      a.href = url;
      return a.href.replace(a.hash, '');
    },
    highlightLink(url) {

      let f = document.getElementById("iframe");
      for (let element of f.contentWindow.document.getElementsByClassName(
              "mark-item-force-show"
      )) {
        element.classList.remove("mark-item-force-show");
      }

      let marked = f.contentWindow.document.getElementsByClassName(
              "mark-item-active"
      );

      for (let element of marked) {
        element.classList.remove("mark-item-active");
      }

      let linkElement = null;
      for (let element of f.contentWindow.document.querySelectorAll('a[href]')){
        if (element.href.replace(element.hash, '') === this.getNormalizedUrl(url)) {
          linkElement = element;

          if (!f.contentWindow.elIsVisible(linkElement)) {
            f.contentWindow.showElem(linkElement);
          }
        }
      }

      if (linkElement) {
        setTimeout(() => {
          linkElement.classList.add(
                  "mark-item-active"
          );
        }, 1);
        f.contentWindow.scrollIntoViewIfNeeded(linkElement);
      }
    },
    highlightSpelling(spellingError, mark, dir = 0) {
      this.showIndex += dir;

      let f = document.getElementById("iframe");
      f.contentWindow.scrollTo(0,0);
      for (let element of f.contentWindow.document.getElementsByClassName(
        "mark-spelling-errors-force-show"
      )) {
        element.classList.remove("mark-spelling-errors-force-show");
      }

      let marked = f.contentWindow.document.getElementsByClassName(
        "mark-spelling-errors"
      );

      for (let element of marked) {
        element.classList.remove("mark-spelling-errors-active");
      }

      let index = Math.max(0, this.showIndex);
      index = Math.min(index, spellingError.marks[mark].elements.length - 1);
      setTimeout(function() {
        spellingError.marks[mark].elements[index].classList.add(
          "mark-spelling-errors-active"
        );
      }, 1);
      this.showIndex =index;

      if (
        !f.contentWindow.elIsVisible(spellingError.marks[mark].elements[index])
      ) {
        f.contentWindow.showElem(spellingError.marks[mark].elements[index]);
      }

      f.contentWindow.scrollIntoViewIfNeeded(
              spellingError.marks[mark].elements[index]
      );

    },
    loadPage() {
      return axios
        .get(`page`, {
          headers: { Accept: "application/json" },
          params: { page: this.$route.query.page, site: this.$route.query.site }
        })
        .then(
          response => {
            this.page = response.data;
            this.inject();
            return true;
          },
          _response => {
            return false;
          }
        );
    },
    iframeload(e) {
      this.iframeLoaded = !!this.page.id;
      if (this.iframeLoaded) {
        this.markAll();
        if (this.$route.query.focus){
          if (this.$route.params.type === 'spelling') {
            this.highlightSpelling(this.spellingErrors.find((v) => {
              return v.word === this.$route.query.focus;
            }), 'visible', 1);
          }
          else if (this.$route.params.type === 'link') {
            this.highlightLink(this.$route.query.focus);

          }
        }

      }
    },
    inject() {
      var doc = document.getElementById("iframe").contentWindow.document;
      doc.open();
      doc.write(this.page.viewer.html);
      doc.close();
    }
  },
  watch: {
    'activeSite': function () {
      this.dataLoaded = false;
    }
  },
  mounted() {
    this.loadPage();
  },
};
</script>

<style src="./Viewer.scss" lang="scss" scoped />
